import react from 'react';
import {Route, Routes, BrowserRouter} from 'react-router-dom';
import Home from './pages/home';
import Login from './pages/login';
import Register from './pages/register'
import Loggedin from './pages/loggedin';
import Dashbord from './pages/Dashbord/main/main'
import LEODashboard from './pages/LEO Dashboard/main/main'
import BCSOMainApplication from './pages/BCSO/applications/mainApplication'
function App() {
  return (
    <div className="App" style={{overflow: 'hidden', backgroundColor: '#eff1f2'}} >
      
    <BrowserRouter style>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path='/register' element={<Register/>} />
        <Route path='/welcome' element={<Dashbord/>} />
        <Route path='/dashboards/leo' element={<LEODashboard />} />
        <Route path='/BCSO/applications/apply' element={<BCSOMainApplication />} />

      </Routes>
    </BrowserRouter>

    </div>
  );
}

export default App;
